import { computed } from "vue";
import { useRoute, useRouter } from "vue-router";

export function useApp() {
  const route = useRoute();
  const router = useRouter();

  const isPreview = computed(() => route.name === "preview");

  const navigateTo = async (path: string) => {
    await router.push({
      path,
      query: route.query,
    });
  };

  return { isPreview, navigateTo };
}
